import { ILead, LeadsService } from '../../../services';

class LeadsItemController {

    private lead: ILead;
    private leadsService: any;

    constructor(LeadsService: LeadsService, private $state: ng.ui.IStateService) {
        'ngInject';       
        // console.log('LeadsItemController');
        this.leadsService = LeadsService;
    }

    submitLead() {
        // console.log('update lead');

        if (this.lead.id == null) {
            this.saveLead();
        } else {
            this.leadsService.put(this.lead.id, this.lead);
        }
    }

    saveLead() {
        this.leadsService.post(this.lead).then(result => {
            this.$state.go('crm.leads.item', {'id': result.id});
        });
    }

    deleteLead() {
        // console.log('delete lead');
        this.leadsService.delete(this.lead.id);

        this.$state.go('^.list').then(() => { this.$state.reload(); });
    }
}

export const leadsItemComponent = {
    bindings: { 
        lead: '<'
     },
    controller : LeadsItemController,
    template : require('./leads.item.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/leads/leads.item.component.ts